import { Component, OnInit, inject } from '@angular/core';
import { Event, RouterEvent, Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { AppConstants } from './app.constants';
import { AnalyticsService } from './core/services/analytics.service';
import { AuthStateService } from './core/services/auth-state.service';
import { ConsentService } from './core/services/consent.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private readonly authState = inject(AuthStateService);
  private readonly consentService = inject(ConsentService);

  constructor(
    public translate: TranslateService,
    public router: Router,
  ) {
    this.setLanguage(translate);

    this.eventsRoutes(router);

    if (!environment.production)
      console.log('RUNNING ENVIRONMENT: ', environment.environmentName);
  }

  ngOnInit(): void {
    // The backend (CosmosDB) is the cross-device source of truth for consent.
    // Reconcile the local cache whenever the user becomes authenticated
    // (fresh login or restored session), so a decision made on another device
    // is reflected here.
    this.authState.isAuthenticated$
      .pipe(distinctUntilChanged(), filter(Boolean))
      .subscribe(() => {
        this.consentService.loadFromBackend();
      });
  }

  setLanguage(translate) {
    const lang = localStorage.getItem(AppConstants.KEYS_LOCAL_STORAGE.ISO_LANG);

    if (lang) {
      translate.use(lang);
    } else {
      translate.setDefaultLang(AppConstants.LANGUAGES.PT_BR);
    }
  }

  eventsRoutes(router) {
    router.events
      .pipe(
        filter((e: Event): e is NavigationEnd => e instanceof NavigationEnd),
      )
      .subscribe((e: NavigationEnd) => {
        this.checkDeviceIsMobile();
      });
  }

  checkDeviceIsMobile() {
    let isDeviceMobile = false;

    if ($('#spanDeviceIsDesktop').css('display') != 'none') {
      isDeviceMobile = true;
    }
  }
}
